import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { UseDataProps } from './types';
import { useStore } from '30.quickConnect.Stores';
import { TreeDataItem } from '30.quickConnect.Stores/helpers/type';
import { DeclarationViewer } from '90.quickConnect.Models/models';
import { EQUIPMENT_DECLARATION_HISTORY } from '10.quickConnect.app/routes/paths';
import { useIsMobile } from '80.quickConnect.Core/hooks';

const useData = (): UseDataProps => {
  const {
    EquipmentsStore: {
      historicalDataViewer: { items: declarations },
    },
  } = useStore();

  const { t } = useTranslation('declaration');
  const navigate = useNavigate();
  const { schemaId, entityId } = useParams();
  const isMobile = useIsMobile();

  const sortFn = (a: TreeDataItem, b: TreeDataItem) => {
    return (b as DeclarationViewer)?.editedAt && (a as DeclarationViewer)?.editedAt
      ? new Date((b as DeclarationViewer).editedAt).getTime() - new Date((a as DeclarationViewer).editedAt).getTime()
      : -1;
  };

  // Ouvre la recherche des anciennes déclarations filtrée sur l'équipement courant
  const navigateToOldDeclaration = useCallback(() => {
    if (schemaId && entityId)
      navigate(EQUIPMENT_DECLARATION_HISTORY.replace(':schemaId', schemaId).replace(':entityId', entityId));
  }, [navigate, schemaId, entityId]);

  return {
    t,
    declarations,
    sortFn,
    isMobile,
    navigateToOldDeclaration,
  };
};

export default useData;
